import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=e1bec4ec&scoped=true&"
import script from "./SocialIcon.vue?vue&type=script&lang=js&"
export * from "./SocialIcon.vue?vue&type=script&lang=js&"
import style0 from "./SocialIcon.vue?vue&type=style&index=0&id=e1bec4ec&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bec4ec",
  null
  
)

export default component.exports